(() => {
  const init = (hero) => {
    if (hero.dataset.gcReady === 'true') return;
    hero.dataset.gcReady = 'true';
    const slides = [...hero.querySelectorAll('[data-gc-slide]')];
    const dots = [...hero.querySelectorAll('[data-gc-dot]')];
    if (slides.length < 2) return;
    let active = 0;
    let timer;
    let startX = 0;
    const mobileViewport = window.matchMedia('(max-width: 767px)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const selected = i === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        slide.inert = !selected;
      });
      dots.forEach((dot, i) => {
        const selected = i === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };
    const stop = () => window.clearInterval(timer);
    const play = () => {
      stop();
      if (!mobileViewport && !reducedMotion && !document.hidden && !hero.contains(document.activeElement)) timer = window.setInterval(() => show(active + 1), 6000);
    };
    hero.querySelector('[data-gc-prev]')?.addEventListener('click', () => { show(active - 1); play(); });
    hero.querySelector('[data-gc-next]')?.addEventListener('click', () => { show(active + 1); play(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.gcDot)); play(); }));
    hero.addEventListener('pointerdown', (event) => { startX = event.clientX; }, { passive: true });
    hero.addEventListener('pointerup', (event) => {
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 55) { show(active + (distance < 0 ? 1 : -1)); play(); }
    }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : play());
    hero.querySelector('.gc-hero__dots')?.setAttribute('role', 'group');
    dots.forEach(dot => dot.removeAttribute('aria-selected'));
    hero.addEventListener('focusin', stop);
    show(0);
    play();
  };
  const initAll = (root = document) => root.querySelectorAll('[data-gc-hero]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
